import axios from "axios";
import {
    toast
} from "react-toastify";

let id;
let cache = {};

const fetchData = async (props) => {
    props = props || {};
    props.headers = props.headers || {};

    const base_url = props.base_url || process.env.REACT_APP_SERVER_URL;
    const token = get_token();
    const headers = token ? {
        ...props.headers,
        authorization: "Bearer " + token
    } : props.headers;
    const url = props.url || "";
    const method = props.method || "GET";
    const body = props.body || {};
    const message = props.message;
    const loading = props.loading;

    if (props.cache && true && cache[url]) return {
        data: cache[url],
        error: undefined
    }

    let data = null;
    let error = null;

    if (loading) {
        id = toast.loading("Please wait...");
    }

    try {
        let response;

        if (!props.files) {
            response = await axios({
                url: base_url + url,
                method: method,
                data: body,
                headers: headers
            });
        } else {
            const form = new FormData();

            props.files.forEach(file => {
                form.append("files", file);
            });

            for (const [key, value] of Object.entries(body)) {
                form.append(key, value);
            }

            response = await axios.post(base_url + url, form, {
                headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: props.onUploadProgress || (() => {})
            })
        }

        data = response.data;
        if (props.cache) cache[url] = JSON.parse(JSON.stringify(data));

        if (message) toast.success(message);
    } catch (err) {
        console.error(err)
        error = err;

    }

    if (loading && id) toast.dismiss(id);


    if (error) {
        const text = !error.response.data?.error ? "Quelque chose s'est mal passé !" : error.response?.data.error;
        toast.error(text);
    }

    return {
        error: error,
        data: data
    }

}

const get_token = () => {
    if (window.sessionStorage.getItem("token")) return window.sessionStorage.getItem("token");

    try {
        let user = window.localStorage.getItem("user");
        user = user ? JSON.parse(user) : null;
        if (user) return user.token;
    } catch (err) {
        return null;
    } 

    return null;
}

export default fetchData;